import { render, staticRenderFns } from "./xianlu.vue?vue&type=template&id=4dfc0bac&scoped=true"
import script from "./xianlu.vue?vue&type=script&lang=js"
export * from "./xianlu.vue?vue&type=script&lang=js"
import style0 from "./xianlu.vue?vue&type=style&index=0&id=4dfc0bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfc0bac",
  null
  
)

export default component.exports